/**
 * The button Board 17 draws in its bands (C, E, G): 32 high, 14 either side,
 * a 9px radius, 12.5px semibold — the board's own numbers. Spelled here
 * rather than as `buttonClass({ className })`, because `cn` joins classes and
 * does not merge them, so a height, radius and size laid over the shared
 * button's would leave the stylesheet's order to decide which one draws.
 */
const BASE = 'inline-flex h-8 items-center justify-center gap-1.5 whitespace-nowrap rounded-control border px-3.5 '
  + 'text-[12.5px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50'

export const BAND_BUTTON = {
  primary: `${BASE} border-accent bg-accent text-white hover:bg-accent-dark`,
  plain: `${BASE} border-line bg-surface text-text hover:bg-hover`,
} as const
